import React, { useState } from 'react';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import dayjs from 'dayjs';


function DatePickeSr({ value, onChange }) {
    const [startDate, setStartDate] = useState(value || new Date());

    const handleChange = (date) => {
        setStartDate(date);
        if (onChange) {
            onChange(date);
        }
    };

    return (
        <>
            <label className="font-poppins block mb-2 text-sm font-medium text-gray-300">Select a Date</label>
            <DatePicker
                className='p-2 font-poppins rounded-lg cursor-pointer text-white bg-gray-600 w-[200px]'
                selected={startDate}
                onChange={handleChange}
                required
                minDate={new Date()} // Disable past dates
            />
        </>
    );
}

export default DatePickeSr;
